import React from 'react'

function Token() {
    return (
        <>
            {/* Token area start */}
            <section className="rts-token-area rts-section-gap">
                <div className="container">
                    <div className="section-inner">
                        <div
                            className="token-hero wow fadeInRight"
                            data-wow-delay=".8s"
                            data-wow-duration="2s"
                        >
                            <img src="assets/images/token/image-03.svg" alt="" />
                        </div>
                        <div className="row">
                            <div className="col-lg-9">
                                <div className="section-title-area">
                                    <p
                                        className="sub-title wow fadeInUp"
                                        data-wow-delay=".2s"
                                        data-wow-duration="2s"
                                    >
                                        How to Buy Token
                                    </p>
                                    <h2
                                        className="section-title wow fadeInUp"
                                        data-wow-delay=".5s"
                                        data-wow-duration="2s"
                                    >
                                        How to Buy CoinCraze <br /> Token in Just a Few Steps!
                                    </h2>
                                </div>
                                <div className="token-feature-area mt--50">
                                    <ul>
                                        <li
                                            className="token-wrapper wow fadeInUp"
                                            data-wow-delay=".8s"
                                            data-wow-duration="1.6s"
                                        >
                                            <h2 className="number">01</h2>
                                            <h4 className="title">Set Up Your Wallet</h4>
                                            <p className="desc mb--0">
                                                Download and install a crypto wallet like MetaMask or Trust
                                                Wallet.
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/token/coin-03.svg"
                                                width={57}
                                                alt=""
                                            />
                                        </li>
                                        <li
                                            className="token-wrapper wow fadeInUp"
                                            data-wow-delay=".9s"
                                            data-wow-duration="1.6s"
                                        >
                                            <h2 className="number">02</h2>
                                            <h4 className="title"> Decentralized Exchange</h4>
                                            <p className="desc mb--0">
                                                Visit a platform like PancakeSwap or Uniswap, then connect
                                                your wallet.
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/token/coin-03.svg"
                                                width={57}
                                                alt=""
                                            />
                                        </li>
                                        <li
                                            className="token-wrapper wow fadeInUp"
                                            data-wow-delay="1s"
                                            data-wow-duration="1.6s"
                                        >
                                            <h2 className="number">03</h2>
                                            <h4 className="title">Import Coin Craze</h4>
                                            <p className="desc mb--0">
                                                Copy and paste the official CoinCraze contract address into
                                                the exchange to import the token.
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/token/coin-03.svg"
                                                width={57}
                                                alt=""
                                            />
                                        </li>
                                        <li
                                            className="token-wrapper wow fadeInUp"
                                            data-wow-delay="1.1s"
                                            data-wow-duration="1.6s"
                                        >
                                            <h2 className="number">04</h2>
                                            <h4 className="title">Confirm and Hold</h4>
                                            <p className="desc mb--0">
                                                Approve the transaction in your wallet, &amp; voilà! Your
                                                CoinCraze tokens are now in your wallet.
                                            </p>
                                            <img
                                                className="shape"
                                                src="assets/images/token/coin-03.svg"
                                                width={57}
                                                alt=""
                                            />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Token area end */}
        </>

    )
}

export default Token